import { clearPending } from "./roomCancellationPublic";
const ACCESS_KEY = "portal_access_token";
const REFRESH_KEY = "portal_refresh_token";
const USER_KEY = "portal_user";
const SESSION_FLAG_KEY = "portal_has_session";

const isBrowser =
  typeof window !== "undefined" &&
  typeof sessionStorage !== "undefined" &&
  typeof localStorage !== "undefined";

function migrateLegacyTokens() {
  if (!isBrowser) return;
  const legacyUser = localStorage.getItem(USER_KEY);
  if (legacyUser) sessionStorage.setItem(USER_KEY, legacyUser);
  localStorage.removeItem(ACCESS_KEY);
  localStorage.removeItem(REFRESH_KEY);
  localStorage.removeItem(USER_KEY);
}

export function persistTokens({ accessToken, refreshToken, user }) {
  if (!isBrowser) return;
  if (accessToken || refreshToken) {
    sessionStorage.removeItem(ACCESS_KEY);
    sessionStorage.removeItem(REFRESH_KEY);
    localStorage.removeItem(ACCESS_KEY);
    localStorage.removeItem(REFRESH_KEY);
  }
  sessionStorage.setItem(SESSION_FLAG_KEY, "1");
  localStorage.setItem(SESSION_FLAG_KEY, "1");
  if (user) sessionStorage.setItem(USER_KEY, JSON.stringify(user));
}

export function clearTokens() {
  if (!isBrowser) return;
  clearPending(sessionStorage);
  sessionStorage.removeItem(ACCESS_KEY);
  sessionStorage.removeItem(REFRESH_KEY);
  sessionStorage.removeItem(USER_KEY);
  sessionStorage.removeItem(SESSION_FLAG_KEY);
  localStorage.removeItem(ACCESS_KEY);
  localStorage.removeItem(REFRESH_KEY);
  localStorage.removeItem(USER_KEY);
  localStorage.removeItem(SESSION_FLAG_KEY);
}

export function getAccessToken() {
  if (!isBrowser) return null;
  migrateLegacyTokens();
  return sessionStorage.getItem(SESSION_FLAG_KEY) || localStorage.getItem(SESSION_FLAG_KEY);
}

export function getRefreshToken() {
  if (!isBrowser) return null;
  migrateLegacyTokens();
  return null;
}

export function getStoredUser() {
  if (!isBrowser) return null;
  migrateLegacyTokens();
  const raw = sessionStorage.getItem(USER_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}
